import React, { Component } from "react";
import { connect } from "react-redux";
import { Menu } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "containers/Sidebar/SidebarLogo";
import IntlMessages from "util/IntlMessages";
import {NAV_STYLE_MINI, THEME_TYPE_LITE} from "constants/ThemeSetting";
import Auxiliary from "util/Auxiliary";
import { FaSitemap, FaBars, FaCalendarAlt, FaBoxes, FaUserTie } from 'react-icons/fa';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class SidebarContent extends Component {

  render() {
    const {navStyle, themeType, verticalNavStyle, pathname} = this.props;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split('/')[1];
    return (
      <Auxiliary>
        <SidebarLogo />
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            inlineCollapsed={verticalNavStyle === NAV_STYLE_MINI}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline"
          >
            <MenuItemGroup key="parlament" title="Parlamento">
              <Menu.Item key="dashboard">
                <Link to="/">
                  <FaBars className="icon" />
                  <span>Dashboard</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="fractions">
                <Link to="/fractions">
                  <FaBoxes className="icon" />
                  <span>Estructura</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="agenda">
                <Link to="/agenda">
                  <FaCalendarAlt className="icon" />
                  <span>Agenda</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="users">
                <Link to="/users">
                  <FaUserTie className="icon" />
                  <span>Usuarios</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="messages">
                <Link to="/messages">
                  <FaUserTie className="icon" />
                  <span>Mensajes</span>
                </Link>
              </Menu.Item>
            </MenuItemGroup>
          </Menu>
        </CustomScrollbars>
      </Auxiliary>
    );
  }
}

SidebarContent.propTypes = {};
const mapStateToProps = ({settings}) => {
  const {navStyle, verticalNavStyle, themeType, locale, pathname} = settings;
  return {navStyle, verticalNavStyle, themeType, locale, pathname}
};
export default connect(mapStateToProps)(SidebarContent);





// WEBPACK FOOTER //
// ./src/containers/Sidebar/SidebarContent.js